var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M22.254.001H4.296C2.29.001.664 1.54.664 3.437v16.987c0 1.898 1.626 3.436 3.632 3.436h17.957c2.006 0 3.632-1.538 3.632-3.436V3.438c0-1.897-1.626-3.436-3.632-3.436m-4.456 6.426h-1.64c-1.286 0-1.535.579-1.535 1.427v1.87h3.067l-.4 2.93h-2.667v7.516h-3.197v-7.517H8.752v-2.93h2.674v-2.16c0-2.506 1.618-3.871 3.982-3.871 1.133 0 2.106.08 2.39.115z"
})));
export default SvgFacebookBlack;